import { Padding } from '@/GlobalStyles';
import { View, ViewProps } from 'react-native';

const ScreenMargin = (props: ViewProps) => {
  return (
    <View
      {...props}
      style={[
        props.style,
        {
          flex: 1,
          marginTop: Padding.p_lg,
          marginHorizontal: Padding.p_lg,
        },
      ]}
    >
      {props.children}
    </View>
  );
};

export default ScreenMargin;
